/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the position of y axis:
 *   * LEFT : left
 *   * RIGHT : right
 */
export enum YAxisPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}
